import { notificationQueryKeys as e } from "./notificationQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { notificationsApi as r } from "@maat/api-notifications";
//#region src/notifications/useMarkNotificationReadMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.markRead(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.unreadCount() });
		}
	});
};
//#endregion
export { i as useMarkNotificationReadMutation };
